import * as ActionsTypes from "../../../../common/constants/stateConstants";

/*---------------------------------------------GET-PACKGE-TO-MODIFY-------------------------------------------------*/
export const getPackageToModifyAction = (payload) => {
  return {
    type: ActionsTypes.GET_PACKAGE_TO_MODIFY,
    payload,
  };
};

export const getPackageToModifySuccessAction = (payload) => {
  return {
    type: ActionsTypes.GET_PACKAGE_TO_MODIFY_SUCCESS,
    payload,
  };
};

export const getPackageToModifyFailAction = (payload) => {
  return {
    type: ActionsTypes.GET_PACKAGE_TO_MODIFY_FAIL,
    payload,
  };
};
/*---------------------------------------------ENVOI-MODIFICATION-PACKAGE-------------------------------------------------*/
export const modificationPackageAction = (payload) => {
  return {
    type: ActionsTypes.MODIFICATION_PACKAGE,
    payload,
  };
};

export const modificationPackageSuccessAction = (payload) => {
  return {
    type: ActionsTypes.MODIFICATION_PACKAGE_SUCCESS,
    payload,
  };
};

export const modificationPackageFailAction = (payload) => {
  return {
    type: ActionsTypes.MODIFICATION_PACKAGE_FAIL,
    payload,
  };
};

export const modificationPackageReinitializationAction = (payload) => {
  return {
    type: ActionsTypes.MODIFICATION_PACKAGE_REINITIALIZATION,
    payload,
  };
};
